"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Audio = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const Audio = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M7.09,36.71v-7.13c0,0-1.1-14.88,13.38-22.47s25.67,0.7,25.67,0.7s11.78,7.79,11.78,19.97v8.92"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M57.03,42.03h3.3c1.2,0,2.17,0.97,2.17,2.17v8.17c0,1.2-0.97,2.17-2.17,2.17h-3.3"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M46.48,61.09c-2.09,0-3.79-1.7-3.79-3.79V37.73c0-2.09,1.7-3.79,3.79-3.79h0c3.5,0,6.33,2.83,6.33,6.33v14.5\r C52.81,58.26,49.98,61.09,46.48,61.09L46.48,61.09z"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M7.97,42.03h-3.3c-1.2,0-2.17,0.97-2.17,2.17v8.17c0,1.2,0.97,2.17,2.17,2.17h3.3"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M18.52,61.09c2.09,0,3.79-1.7,3.79-3.79V37.73c0-2.09-1.7-3.79-3.79-3.79h0c-3.5,0-6.33,2.83-6.33,6.33v14.5\r C12.19,58.26,15.02,61.09,18.52,61.09L18.52,61.09z"
          })]
        })]
      })]
    })
  });
};
exports.Audio = Audio;